import { getConfigValue } from '../runtimeConfig.js';

const MS_IN_DAY = 24 * 60 * 60 * 1000;

const startOfDayUtc = (date: Date): Date => {
  const clone = new Date(date);
  clone.setUTCHours(0, 0, 0, 0);
  return clone;
};

export const addDays = (date: Date, days: number) => new Date(date.getTime() + days * MS_IN_DAY);

export interface RelevantWindow {
  from: Date;
  to: Date;
}

export const getDefaultRelevantWindow = (
  baseDate = new Date(),
  relevantWindowDays = Number(getConfigValue('VITE_RELEVANT_WINDOW_DAYS') ?? 7),
  freshnessOffsetDays = Number(getConfigValue('VITE_FRESHNESS_OFFSET_DAYS') ?? 10)
): RelevantWindow => {
  const endExclusive = startOfDayUtc(addDays(baseDate, -freshnessOffsetDays));
  const startInclusive = startOfDayUtc(addDays(endExclusive, -relevantWindowDays));
  return {
    from: startInclusive,
    to: endExclusive,
  };
};

export const formatDateInputValue = (date: Date) => date.toISOString().split('T')[0];

export const parseDateInput = (value: string): Date | null => {
  if (!value) return null;
  const parts = value.split('-');
  if (parts.length !== 3) return null;
  const [year, month, day] = parts.map(Number);
  if ([year, month, day].some((v) => Number.isNaN(v))) return null;
  return new Date(Date.UTC(year, month - 1, day));
};

export const toIsoDate = (date: Date) => date.toISOString();

export const getLatestAllowedDate = (
  baseDate = new Date(),
  freshnessOffsetDays = Number(getConfigValue('VITE_FRESHNESS_OFFSET_DAYS') ?? 10)
) => startOfDayUtc(addDays(baseDate, -freshnessOffsetDays));
